module.exports = __webpack_public_path__ + "img/RECUADRO_Training.c7af29e4.png";